var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.4,
    height: 18,
    viewBox: "0 0 14.4 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M11.2,11.9a1.341,1.341,0,0,0-.9,2.349V15.5a.9.9,0,1,0,1.8,0V14.249a1.341,1.341,0,0,0-.9-2.349Zm4.5-3.6V6.5a4.5,4.5,0,1,0-9,0V8.3A2.7,2.7,0,0,0,4,11v6.3A2.7,2.7,0,0,0,6.7,20h9a2.7,2.7,0,0,0,2.7-2.7V11A2.7,2.7,0,0,0,15.7,8.3ZM8.5,6.5a2.7,2.7,0,0,1,5.4,0V8.3H8.5Zm8.1,10.8a.9.9,0,0,1-.9.9h-9a.9.9,0,0,1-.9-.9V11a.9.9,0,0,1,.9-.9h9a.9.9,0,0,1,.9.9Z",
    transform: "translate(-4 -2)",
    fill: "#707070",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.feefbf156884235741d0235f99924cf5.svg";
export { ForwardRef as ReactComponent };